<template>
  <div class="home">
    <b-container class="bv-example-row">
      <b-row>
        <b-col class="p-0 menu">
          <Menu />
        </b-col cols="12" md="auto">
        <b-col>
          <Header />

          <b-container class="dashboard-content">

            Questions, answers, and scene configurations should be added to this matrix.<br />
            Dynamic responses should be identified with two hashtags. i.e. ##head<br /><br />
            <b-link @click="downloadQAMatrix()">Click here</b-link> to download <b><i>all</i></b> items in the QA Matrix (may take some time).<br />

            <Spinner v-show="showSpinner" /><br />



            <b-table-simple hover small responsive borderless class="matrix">

              <b-thead class="bg-dkblue text-white">
                <b-tr>
                  <b-th style="width:4rem;" rowspan=3>ID</b-th>
                  <b-th colspan=3>Parameters</b-th>
                  <b-th style="width:3rem;" rowspan=3></b-th>
                </b-tr>
              </b-thead>

              <b-tbody class="matrix-table">
                <b-tr>
                  <b-td rowspan=4><b-form-input v-model="newItem.id" class="table-input" type="number" placeholder="999"></b-form-input></b-td>
                  <b-td colspan=3><b-form-input v-model="newItem.question" class="table-input" type="text" placeholder="Question"></b-form-input></b-td>
                  <b-td rowspan=4>
                    <b-link @click=""><b-icon @click="addQAItem(newItem.id)" icon="plus-square"></b-icon></b-link><br />
                    <b-link @click=""><b-icon @click="nlpTokenize(newItem.question)" icon="calculator"></b-icon></b-link>
                  </b-td>
                </b-tr>
                <b-tr><b-td colspan=3><b-form-input v-model="newItem.response" class="table-input" type="text" placeholder="Response"></b-form-input></b-td></b-tr>
                <b-tr>
                  <b-td><b-form-input v-model="newItem.fg" class="table-input" type="text" placeholder="Foreground Media"></b-form-input></b-td>
                  <b-td><b-form-input v-model="newItem.bg" class="table-input" type="text" placeholder="Background Media"></b-form-input></b-td>
                  <b-td><b-form-input v-model="newItem.lighting" class="table-input" type="text" placeholder="Lighting Preset"></b-form-input></b-td>
                </b-tr>
                <b-tr>
                  <b-td><b-form-input v-model="newItem.type" class="table-input" type="text" placeholder="Type"></b-form-input></b-td>
                  <b-td colspan=2><b-form-input v-model="newItem.keywords" class="table-input" type="text" placeholder="Keywords"></b-form-input></b-td>
                </b-tr>
              </b-tbody>



              <b-tbody style="border-top: 1px solid;" class="matrix-table" v-for="result in results">
                <b-tr>
                  <b-td rowspan=4>{{ result.id }}</b-td>
                  <b-td colspan=3><b>Q:  </b>{{ result.question }}</b-td>
                  <b-td rowspan=4>
                    <b-link @click="confirmDelete(result.id)"><b-icon @click="" icon="x-square"></b-icon></b-link><br />
                    <b-link @click="editQAItem(result.id)"><b-icon @click="" icon="pencil-square"></b-icon></b-link><br />
                    <b-link @click=""><b-icon @click="recalculateNlpTokens(result.id)" icon="calculator"></b-icon></b-link>
                  </b-td>
                </b-tr>
                <b-tr><b-td colspan=3><b>A:  </b>{{ result.response }}</b-td></b-tr>
                <b-tr>
                  <b-td><b>FG:  </b>{{ result.fg }}</b-td>
                  <b-td><b>BG:  </b>{{ result.bg }}</b-td>
                  <b-td><b>LX:  </b>{{ result.lighting }}</b-td>
                </b-tr>
                <b-tr>
                  <b-td><b>Type: </b>{{ result.type }}</b-td>
                  <b-td colspan=2><b>Keywords:  </b>{{ result.keywords }}</b-td>
                </b-tr>
              </b-tbody>



            </b-table-simple>


          </b-container>

        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src
import Menu from '@/components/Menu.vue'
import Header from '@/components/Header.vue'
import Spinner from '@/components/Spinner.vue'
import dateFormat, { masks }  from 'dateformat';
const axios = require('axios')

export default {
  name: 'qa_matrix', 
  data(){
    return {
        showSpinner: false,
        newItem: {
          id: null,
          question: null,
          response: null,
          fg: null,
          bg: null,
          lighting: null,
          type: null,
          keywords: null
        },
        results: []
      }
  },
  mounted() {
    this.showSpinner = true,
    this.$store.state.page = "Q&A Matrix"
    this.getQAItems()



  },
  computed: {
    user () {
      return this.$store.state.user
      // { "logged": true, "loggedInAs": { "name": "Alok Wadhwani", "email": "alok@alokw.com" } }
    },
  },
  components: {
    Menu,
    Header,
    Spinner
  },
  methods: {

    downloadQAMatrix() {
      this.showSpinner = true
      //this.results = []
      var url = this.$store.state.locals.apiUrl + '/downloadQAMatrix'
      var config = {
        method: 'get',
        url: url,
        responseType: 'blob', // important
        headers: { 
          'api-key': this.$apikey, 
          'Content-Type': 'application/json'
        }
      };

      axios(config)
      .then((response) => {

        var now = new Date();
        var stamp = dateFormat(now, "yyyy-mm-dd_HH-MM-ss");
        var filename = 'mdcai_qa_matrix_' + stamp + '.xlsx'

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); //or any other extension
        document.body.appendChild(link);
        link.click();
        //this.results = response.data,
        //this.parseActivityLog(response.data),
        this.showSpinner = false

      })
      .catch((error) => {
        console.log(error);
        this.$store.state.error = error;
        this.$router.push('dashboard_error')
      });
    },

    testPopup() {
      alert('test popup')
    },

    editQAItem(id) {
      // find item by id
      let selected = this.results.find(el => el.id === id);
      this.newItem.id = selected.id
      this.newItem.question = selected.question
      this.newItem.response = selected.response
      this.newItem.fg = selected.fg
      this.newItem.bg = selected.bg
      this.newItem.lighting = selected.lighting
      this.newItem.type = selected.type
      this.newItem.keywords = selected.keywords
    },


    recalculateNlpTokens(id) {
      this.showSpinner = true

      var data = { "id": id }
      var url = this.$store.state.locals.apiUrl + '/recalculateNlpTokens'
      var config = {
        method: 'post',
        url: url,
        headers: { 
          'api-key': this.$apikey, 
          'Content-Type': 'application/json'
        },
        data : data
      };

      axios(config)
      .then((response) => {
        this.getQAItems()
        this.showSpinner = false

      })
      .catch((error) => {
        console.log(error);
        this.$store.state.error = error;
        this.$router.push('dashboard_error')
      });

      },



    nlpTokenize(question) {
      this.showSpinner = true
      // find item by id
      
      var data = { text: question }
      var url = this.$store.state.locals.apiUrl + '/nlpTokenize'
      var config = {
        method: 'post',
        url: url,
        headers: { 
          'api-key': this.$apikey, 
          'Content-Type': 'application/json'
        },
        data : data
      };

      axios(config)
      .then((response) => {
        //this.results = response.data,
        //this.parseWhitelist(response.data),
        this.newItem.type = response.data.type
        var keywords = response.data.keywords
        this.newItem.keywords = String(keywords).replace(/[\[\]']+/g,'').replaceAll(',', ', ')
        //console.log(response)
        this.showSpinner = false

      })
      .catch((error) => {
        console.log(error);
        this.$store.state.error = error;
        this.$router.push('dashboard_error')
      });
    

    },

    addQAItem(id) {

      this.showSpinner = true

      // id is not set - need to set an ID
      if (id == null) {
        this.$bvModal.msgBoxConfirm('You must set an ID to save an item.', {
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(value => {
            console.log(value)
            //this.boxOne = value
          })
          .catch(err => {
            // An error occurred
          })

        this.showSpinner = false
        

      } else {

        // check if id is already in use, and is okay to overwrite
        let selected = this.results.find(el => el.id === id);
        if (typeof selected !== 'undefined') {
          //console.log('id already in use, okay to overwrite?')
          this.$bvModal.msgBoxConfirm('This ID already exists. Okay to overwrite?', {
            size: 'sm',
            buttonSize: 'sm',
            okTitle: 'Yes',
            cancelTitle: 'No',
            okVariant: 'danger',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          })
            .then(value => {
              if (value == true) {

                // overwrite entry
                //console.log('okay to overwrite')

                /// make data lowercase
                var data = JSON.parse(JSON.stringify(this.newItem, function(a, b) {
                  return typeof b === "string" ? b.toLowerCase() : b
                }));

                var url = this.$store.state.locals.apiUrl + '/updateQAItem'
                var config = {
                  method: 'put',
                  url: url,
                  headers: { 
                    'api-key': this.$apikey, 
                    'Content-Type': 'application/json'
                  },
                  data : data
                };

                axios(config)
                .then((response) => {
                  this.getQAItems()
                  this.showSpinner = false

                })
                .catch((error) => {
                  console.log(error);
                  this.$store.state.error = error;
                  this.$router.push('dashboard_error')
                });

              } else {
                //console.log('bailout')
              }
            })
            .catch(err => {
              // An error occurred
            })

          this.showSpinner = false

        } else {

          // id is unique - okay to add QA item
          //console.log('id is unique, okay to use')

          // make all json data lowercase
          var data = JSON.parse(JSON.stringify(this.newItem, function(a, b) {
            return typeof b === "string" ? b.toLowerCase() : b
          }));

          var url = this.$store.state.locals.apiUrl + '/addQAItem'
          var config = {
            method: 'put',
            url: url,
            headers: { 
              'api-key': this.$apikey, 
              'Content-Type': 'application/json'
            },
            data : data
          };

          axios(config)
          .then((response) => {
            this.getQAItems()
            this.showSpinner = false

          })
          .catch((error) => {
            console.log(error);
            this.$store.state.error = error;
            this.$router.push('dashboard_error')
          });

        } // end of add qa item


      }

    },


    deleteQAItem(id) {
      this.showSpinner = true

      var data = { "id": id }
      var url = this.$store.state.locals.apiUrl + '/deleteQAItem'
      var config = {
        method: 'delete',
        url: url,
        headers: { 
          'api-key': this.$apikey, 
          'Content-Type': 'application/json'
        },
        data : data
      };

      axios(config)
      .then((response) => {
        this.getQAItems()
        this.showSpinner = false

      })
      .catch((error) => {
        console.log(error);
        this.$store.state.error = error;
        this.$router.push('dashboard_error')
      });
    },

    getQAItems() {
      this.results = []
      var url = this.$store.state.locals.apiUrl + '/getQAItems'
      var config = {
        method: 'get',
        url: url,
        headers: { 
          'api-key': this.$apikey, 
          'Content-Type': 'application/json'
        }
      };

      axios(config)
      .then((response) => {
        this.results = response.data,
        //this.parseWhitelist(response.data),
        this.showSpinner = false

      })
      .catch((error) => {
        console.log(error);
        this.$store.state.error = error;
        this.$router.push('dashboard_error')
      });
    },

    confirmDelete(id) {
        this.$bvModal.msgBoxConfirm('Are you sure you want to remove ID ' + id + ' from the matrix?', {
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(value => {
            if ( value == true ) {
             this.deleteQAItem(id)
            }
          })
          .catch(err => {
            console.log(err)
          })
    }

  }
}
</script>
